import React from 'react';
import VitalSigns from './vital_signs';
import Controls from './controls_bar';
import { useSnapshot } from 'valtio';
import { refsStore, eventsStore, poiStore, gmapStore } from '../managers/globalState';

const VSFooter = ({ vsProps, controlsProps, closeTimeControls, closeTimeControlsVisible }) => {
	const { showOnGlobe } = useSnapshot(eventsStore.state);
	const { showOnGlobePoI } = useSnapshot(poiStore.state);
	const { showOnGlobeGmap } = useSnapshot(gmapStore.state);
	const { get } = useSnapshot(refsStore.state);


	//	copy by value so we will not modify the original object
	const localVsProps = { ...vsProps };
	let showEvenTitle = false;
	let showPoITitle = false;
	let showGmapTitle = false;
	const router = get('route');

	if (router?._history?.location?.pathname) {
		const { pathname } = router._history.location;

		showEvenTitle = pathname.indexOf('event') >= 0 || pathname.indexOf('spacecraft') >= 0;
		showPoITitle = pathname.indexOf('poi') >= 0 || pathname.indexOf('spacecraft') >= 0;
		showGmapTitle = pathname.indexOf('gmap') >= 0 || pathname.indexOf('spacecraft') >= 0;
	}

	if (showOnGlobe && !showEvenTitle) {
		localVsProps.view = 'event';
	} else if (showOnGlobePoI && !showPoITitle) {
		localVsProps.view = 'poi';
	} else if (showOnGlobeGmap && !showGmapTitle) {
		localVsProps.view = 'gmap';
	}
	

	return (
		<div className='flexbox-container d-none d-lg-flex'>
			<VitalSigns {...localVsProps} />
			<Controls {...controlsProps} closeTimeControls={closeTimeControls} closeTimeControlsVisible={closeTimeControlsVisible} />
		</div>
	);
};

export default VSFooter;
